import type { Product } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_CART_PRODUCT_FIELDS } from '@@partner:graphql/shortcuts'

export interface CartFetchProductDetails {
  productDetails: Product
}

export interface CartFetchProductDetailsVariables {
  productId?: GQL_ID
  shopId?: GQL_ID
}

export const GQL_QUERY_FETCH_PRODUCT_DETAILS = gql`
  query($productId: ID!, $shopId: ID!) {
    productDetails: cartProductDetails(id: $productId, shop_id: $shopId) {
      ${SHORTCUT_CART_PRODUCT_FIELDS}
    }
  }
`

export const useCartFetchCartProductDetails = (
  productId?: GQL_ID,
  shopId?: GQL_ID
) => {
  return useQuery<CartFetchProductDetails, CartFetchProductDetailsVariables>(
    GQL_QUERY_FETCH_PRODUCT_DETAILS,
    {
      variables: {
        productId,
        shopId
      },
      skip: !productId || !shopId,
      fetchPolicy: 'network-only'
    }
  )
}
